import { Award, ShieldCheck, Clock, Wrench, Snowflake } from "lucide-react";

const ITEMS = [
  { icon: Award, label: "Lennox Dealer" },
  { icon: ShieldCheck, label: "Licensed & Insured" },
  { icon: Clock, label: "24/7 Emergency Response" },
  { icon: Wrench, label: "Factory-Trained Technicians" },
  { icon: Snowflake, label: "Heating · Cooling · IAQ" },
];

export default function TrustBar() {
  return (
    <section data-testid="trust-bar" className="border-y border-slate-100 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-6">
          {ITEMS.map((it) => {
            const Icon = it.icon;
            return (
              <div
                key={it.label}
                className="flex items-center gap-3 justify-center md:justify-start"
                data-testid={`trust-${it.label.toLowerCase().replace(/\s|·|&/g, "-")}`}
              >
                <div className="w-10 h-10 rounded-xl bg-white border border-slate-200 flex items-center justify-center shadow-sm">
                  <Icon className="w-5 h-5 text-[#0F172A]" strokeWidth={2} />
                </div>
                <span className="text-sm font-semibold text-slate-700 tracking-tight">
                  {it.label}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
